import { NavLink } from "react-router-dom";

const TopBar = () => {
  const adminRole = parseInt(localStorage.getItem('@admin_role'), 10);

  return (
    <div className="row py-2 start-0 bg-light">
      <div className="col-md-12 col-sm-12 mx-auto text-center">
        <div className="container-fluid z-2">
          
          <NavLink
            to="/admin/work-orders-active"
            end
            className={({ isActive }) =>
              `btn ${isActive ? "btn-success" : "btn-warning"} rounded-0 me-1`
            }
          >
            ACTIVE
          </NavLink>

          {adminRole === 1 && (
            <>
              <NavLink
                to="/admin/work-orders-invoice-needed"
                className={({ isActive }) =>
                  `btn ${isActive ? "btn-success" : "btn-warning"} rounded-0 me-1`
                }
              >
                INVOICE NEEDED
              </NavLink>

              <NavLink
                to="/admin/work-orders-records-obtained"
                className={({ isActive }) =>
                  `btn ${isActive ? "btn-success" : "btn-warning"} rounded-0 me-1`
                }
              >
                RECORDS OBTAINED
              </NavLink>

              <NavLink
                to="/admin/work-orders-closed"
                className={({ isActive }) =>
                  `btn ${isActive ? "btn-success" : "btn-warning"} rounded-0 me-1`
                }
              >
                CLOSED
              </NavLink>

              <NavLink
                to="/admin/work-orders-archived"
                className={({ isActive }) =>
                  `btn ${isActive ? "btn-success" : "btn-warning"} rounded-0 me-1`
                }
              >
                ARCHIVED
              </NavLink>
            </>
          )}
   {adminRole >= 0 && (
    <>
          <NavLink
            to="/admin/work-orders-canceled"
            className={({ isActive }) =>
              `btn ${isActive ? "btn-success" : "btn-warning"} rounded-0 me-1`
            }
          >
            CANCELED
          </NavLink>

          <NavLink
            to="/admin/work-orders-incomplete"
            className={({ isActive }) =>
              `btn ${isActive ? "btn-success" : "btn-warning"} rounded-0 me-1`
            }
          >
            INCOMPLETE
          </NavLink>
</>
   )}
          <NavLink
            to="/admin/work-orders-missing"
            className={({ isActive }) =>
              `btn ${isActive ? "btn-success" : "btn-warning"} rounded-0`
            }
          >
            MISSING
          </NavLink>

        </div>
      </div>
    </div>
  );
};

export default TopBar;